import React, { Component } from 'react'
import _ from 'lodash'
import { RoomColors } from '../../constants/common'
import './styles.scss'
import history from '../history'

class EditRoom extends Component {
  constructor() {
    super()
    this.state = {
      rooms: [],
      data: [],
      disableBtn: false
    }
    this.roomColors = RoomColors
  }

  componentWillMount() {
    const { fetchRooms } = this.props
    fetchRooms()
  }

  componentWillReceiveProps(np) {
    const { rooms, setNick, setNickName } = np
    if (this.props.rooms !== rooms) {
      this.setState({ rooms })
    }
    if (setNick) {
      // Call setNickName api and will always pass first element from the sliced data, till it gets empty
      const data = this.state.data.slice()
      data.splice(0, 1)
      this.setState({ data }, () => {
        if (data.length === 0) {
          // return back to privious page on api success
          history.push('/account-info')
        } else {
          const room = _.first(this.state.data)
          setNickName(room)
        }
      })
    }
  }

  componentWillUnmount() {
    const { clearCozyProps } = this.props
    // Reset all the edit room props on component unmount
    clearCozyProps()
  }

  handleNickNameChange(e, i) {
    const { rooms } = this.state
    if (e.target.value.length < 31) {
      rooms[i].nickname = e.target.value
      this.setState({ rooms })
    }
  }

  // API call
  saveNickName() {
    const { setNickName } = this.props
    const { rooms } = this.state
    this.setState({ data: rooms, disableBtn: true }, () => {
      const room = _.first(this.state.data)
      setNickName(room)
    })
  }

  // Pick color to display in background
  getColor(index) {
    if (index < _.size(RoomColors)) {
      return this.roomColors[index]
    } else {
      return _.sample(this.roomColors)
    }
  }

  render() {
    const { rooms, disableBtn } = this.state
    return (
      <div>
        <main id="EditRoom">
          <div className="wrapper">
            <header className="header display-flex">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <h3 className="secondary-title">Edit Room Names</h3>
                    <div className="close">
                      <a onClick={() => history.goBack()}>
                        <img alt="" src="/img/close-icon.png" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </header>
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="container-inner">
                    {rooms &&
                      rooms.map((room, i) => {
                        return (
                          <div className="barcode-box" key={i} style={{ backgroundColor: this.getColor(i) }}>
                            <div className="edit-room-name">
                              <input
                                type="text"
                                className="form-control"
                                style={{ color: '#ffffff' }}
                                name="cardNumber"
                                placeholder="Nickname"
                                value={_.get(room, 'nickname') || ''}
                                onChange={e => this.handleNickNameChange(e, i)}
                              />
                            </div>
                            {room.covers.length > 0 ? (
                              room.covers.map((cover, i2) => {
                                return (
                                  <div className="input-group" key={i2}>
                                    <div className="input-group-prepend">
                                      <span className="input-group-text">
                                        <img alt="" src="img/barcode_icon.svg" />
                                      </span>
                                    </div>
                                    <input
                                      type="text"
                                      readOnly
                                      defaultValue={cover.barcode}
                                      className="form-control"
                                      style={{ color: '#ffffff' }}
                                      name="cardNumber"
                                      placeholder="123456"
                                    />
                                  </div>
                                )
                              })
                            ) : (
                              <div className="input-group">
                                <div className="input-group-prepend">
                                  <span className="input-group-text">
                                    <img alt="" src="img/barcode_icon.svg" />
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        )
                      })}
                    <footer>
                      <div className="footer-inner">
                        <button
                          disabled={disableBtn}
                          className="btn btn-primary btn-lg btn-block"
                          onClick={() => this.saveNickName()}
                        >
                          Save
                        </button>
                      </div>
                    </footer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    )
  }
}
export default EditRoom



// WEBPACK FOOTER //
// ./src/views/EditRoom/component.js